/**
 * Created by MateuszWaligora on 14.07.2017.
 */
import Vue from 'vue';
import {HTTPCODES} from '../../plugins/types';
/**
 * @module Store/view
 * @description Module for products
 */

/**
 * @constant State of orders store
 * @type {object}
 * */
const state = {
    printers: [],
    formats: []
};

/**
 * @constant Getters
 * @type {object}
 * */
const getters = {
    getPrinters: state => state.printers,
    getFormats: state => state.formats
};

/**
 * @constant Mutations
 * @type {object}
 * */
const mutations = {
    updatePrinters: (state, printers) => state.printers = printers,
    addPrinter: (state, printer) => state.printers.push(printer),
    updateFormats: (state, payload) => state.formats = payload
};

/**
 * @constant Actions
 * @type {object}

 * */
const actions = {
    async findCubesAsync ({}) {
        try {
            let { data } = await Vue.axios.get('/ordermanager/cubes');
            return data;
        } catch (err) {

            throw new Error(err);
        }
    },
    async getPrintersAsync ({commit, rootState}, ip) {
        try {
            let {data} = await Vue.axios.get(`${ip}${rootState.config.printerManager}/printer-device`);
            return {printers: data, ip};
        } catch (err) {
            if(err.response && err.response.status >= 400) {
                if(err.response.status === 401) {
                    return {err: HTTPCODES[err.response.status]};
                }
            }
            commit('addAlert', {
                title: 'Failed ',
                type: 'danger',
                body: 'get printers collection'
            });
            throw new Error(err);
        }
    },
    async getPrinterStatus ({rootState, commit}, ip) {
        try {
            let {data} = await Vue.axios.get(`${ip}${rootState.config.printerManager}/status`);
            return {data};
        } catch (err) {
            if(err.response && err.response.status >= 400) {
                if(err.response.status === 401) {
                    return {err: HTTPCODES[err.response.status]};
                }
            }
            commit('addAlert', {
                title: 'Failed ',
                type: 'danger',
                body: 'to get printer status'
            });
            throw new Error(err);
        }
    },
    async getPrinterMedia ({rootState, commit}, ip) {
        try {
            let {data} = await Vue.axios.get(`${ip}${rootState.config.printerManager}/media`);
            return {data};
        } catch (err) {
            if(err.response && err.response.status >= 400) {
                return {err: HTTPCODES[err.response.status]};
            }
            commit('addAlert', {
                title: 'Failed ',
                type: 'danger',
                body: 'to get printer media information'
            });
            throw new Error(err);
        }
    },

    /**
     * @function getFormatsListAsync
     * @description async action that fetches the formats from the server
     * @returns {Object} format list or error object
     * */
    async getFormatsListAsync ({commit, rootState}) {
        try {
            let {data} = await Vue.axios.get(`${rootState.config.printerManager}/format`);
            commit('updateFormats', data || []);
            return {data};
        } catch (err) {
            if(err.response && err.response.status >= 400) {
                if(err.response.status === 401) {
                    return {err: HTTPCODES[err.response.status]};
                }
            }
            commit('addAlert', {
                title: 'Failed ',
                type: 'danger',
                body: 'to get format list'
            });
            commit('updateFormats', []);
            throw new Error(err);
        }
    }
};

export default {
    state,
    getters,
    mutations,
    actions
};
